import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../store';

export interface SidebarState {
  isOpen: boolean;
  scrollPosition: number;
}

const initialState: SidebarState = {
  isOpen: false,
  scrollPosition: 0,
};

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    openSidebar: (state) => {
      state.isOpen = true;
    },
    closeSidebar: (state) => {
      state.isOpen = false;
    },
    toggleSidebar: (state) => {
      state.isOpen = !state.isOpen;
    },
    setScrollPosition: (state, action: PayloadAction<number>) => {
      state.scrollPosition = action.payload;
    },
  },
});

export const { openSidebar, closeSidebar, toggleSidebar, setScrollPosition} = sidebarSlice.actions;

export const selectIsSidebarOpen = (state: RootState) => state.sidebar.isOpen;

export default sidebarSlice.reducer;

export const selectScrollPosition = (state: RootState) => state.sidebar.scrollPosition;
